import styled from "@emotion/styled";
import {
  color,
  typography,
  space,
  variant,
  position,
  layout,
  flexbox,
} from "styled-system";

const variants = {
  uppercase: {
    textTransform: "uppercase",
  },
  strong: {
    fontWeight: 700,
  },
};

const Text = styled.p`
  margin: 0;
  line-height: 1.2;

  ${variant({ variants })}
  ${color}
  ${typography}
  ${space}
  ${layout}
  ${position}
  ${flexbox}
`;

export default Text;
